import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Snackbar from '@mui/material/Snackbar';
import MDBox from 'components/MDBox';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from 'examples/Footer';
import { apiGetOwnerMachines } from '../../api/machine.api'; // API 호출 함수 임포트
import { useData } from '../../hooks';
import MachineCard from 'examples/Cards/MachineCard';
import { apiRequestPetCollect } from '../../api/petcollect.api';

const Machines = () => {
  const [machines, setMachines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const { user, appIsReady } = useData();

  useEffect(() => {
    if (appIsReady && user) {
      fetchMachines();
    }
  }, [user, appIsReady]);

  const fetchMachines = async () => {
    setLoading(true);
    try {
      const response = await apiGetOwnerMachines(user.userid, user.accessToken); // 소유자의 모든 머신 데이터 불러오기
      if (response) {
        setMachines(response);
      } else {
        console.log('No data received');
      }
    } catch (error) {
      console.error('Failed to load machines:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRequestPickup = async (machineId) => {
    console.log(`Request pickup for machine ID: ${machineId}`);
    try {
      const response = await apiRequestPetCollect(
        { machine_id: machineId },
        user.accessToken,
      );
      if (response === 'success') {
        setSnackbarMessage('요청이 접수되었습니다.');
      } else {
        setSnackbarMessage('요청 처리에 실패했습니다.');
      }
    } catch (error) {
      setSnackbarMessage('요청 처리 중 오류가 발생했습니다.');
    } finally {
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          {machines.map((machine) => (
            <Grid item xs={5} minWidth='400px' key={machine.PetMachine_id}>
              <MDBox mb={1.5}>
                <MachineCard
                  color={
                    machine.PetMachine_status === 'on'
                      ? 'success'
                      : machine.PetMachine_status === 'off'
                        ? 'dark'
                        : 'warning'
                  }
                  icon={
                    machine.PetMachine_status === 'on'
                      ? 'online'
                      : machine.PetMachine_status === 'off'
                        ? 'offline'
                        : 'full'
                  }
                  deviceName={machine.PetMachine_device_name}
                  branchId={machine.PetMachine_branch_id}
                  address={machine.PetMachine_address}
                  sido={machine.PetMachine_sido}
                  useTime={machine.PetMachine_use_time}
                  petCount={machine.pet_cnt_sum ? machine.pet_cnt_sum : '0'}
                  status={machine.PetMachine_status}
                  onRequestPickup={() =>
                    handleRequestPickup(machine.PetMachine_id)
                  }
                />
              </MDBox>
            </Grid>
          ))}
        </Grid>
      </MDBox>
      <Footer />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
      />
    </DashboardLayout>
  );
};

export default Machines;
